export interface Expense {
  expense_forDate: Date;
  expense_title: string;
  expense_category: string;
  expense_receipt: string;
  expense_description: string;
  token: string;
  amount: string;
  expense_id?: string;
  
}

export interface ExpenseDetail {
  createdOn: string;
  expense_category: string;
  expense_description: string;
  expense_forDate: string;
  expense_id: string;
  expense_receipt: string;
  status: string;
  user_id: string;
  usr_role_track_id: string;
  amount: string;
  expense_title: string;
}
